// Main-PDP add-to-cart analytics (add_to_cart_pdp / add_to_cart_atPDP_sticky), pushed with the
// resulting cart line. Moved verbatim from the retired snippets/cart-item-popup.liquid
// (renderFirstItem) — payload is raw Shopify CENTS on purpose: the GTM container's reshaper
// divides these two events by 100.
function pushPdpAddToCartEvent(item, isFromSticky) {
  if (!item) return;
  window.dataLayer = window.dataLayer || [];
  // The data layer is persistent and GTM merges objects recursively (and arrays BY INDEX),
  // so without this reset the previous ecommerce payload leaks into this one.
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    'event': isFromSticky ? "add_to_cart_atPDP_sticky" : "add_to_cart_pdp",
    'ecommerce': {
      'currency': "INR",
      'value': parseFloat(item.original_price.toFixed(2)),
      'items': [
        {
          // item_id is the Shopify PRODUCT id everywhere, so GA4 can join
          // view_item -> add_to_cart -> purchase on one key. SKU and variant id
          // travel alongside as item-scoped dimensions.
          'item_id': String(item.product_id),
          'item_sku': item.sku,
          'item_variant_id': String(item.variant_id),
          'item_name': item.product_title,
          'discount': item.original_price - item.discounted_price,
          'index': 0,
          'item_brand': "SleepyCat",
          'item_category': item.product_type,
          'price': parseFloat(item.original_price.toFixed(2)),
          'item_variant': item.variant_title,
          'quantity': item.quantity,
          'deal-price': parseFloat(item.discounted_price.toFixed(2)),
          'product-category': item.product_type,
          'product-size': item.options_with_values.find(opt => opt.name === "DIMENSION")?.value,
          'product-color': item.options_with_values.find(opt => opt.name === 'COLOR')?.value,
          'page-path': item.url
        }
      ]
    }
  });
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const isFromSticky = this.submitButton.getAttribute('data-clicked-from') === 'sticky';
if (isFromSticky) {
    this.submitButton.removeAttribute('data-clicked-from');
}

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const qtyInput = document.querySelector(".product-form__quantity quantity-input input");
        // const personalizeblock = document.querySelector(".personalize_product_block");
        var personalize_price;
        var mainProductPrice;
        var mainProductComPrice;
        var dataPersonalizeId;
        
        // Guarded: this element is absent on some product templates. Both this and the
        // localStorage read below run AFTER preventDefault() and after the loading spinner is
        // shown, but BEFORE the /cart/add fetch — so an uncaught throw here leaves the button
        // stuck in "loading" with the item never added, and no error the shopper can see.
        const comparePriceEl = document.querySelector(".product__info-wrapper .compare_price");
        const comparePrice = comparePriceEl ? comparePriceEl.getAttribute("data-compare-price") : null;
        const uniqueId = Date.now();
        const formData = new FormData(this.form);

        // localStorage THROWS (rather than returning null) where DOM storage is disabled or
        // partitioned — a documented Android webview default, i.e. in-app browsers.
        var checkIsCustom = null;
        try {
          checkIsCustom = localStorage.getItem("customSize");
        } catch (e) {
          checkIsCustom = null;
        }
        // console.log("checkIsCustom",checkIsCustom);
        let isDrawer;
       
        // PERF (2026-08-24): removed console.log("checkIsCustom", isDrawer) — isDrawer is
        // declared on the line above and only assigned much later in the .then(), so this
        // logged `undefined` on every add-to-cart. Pure noise on the ATC critical path.
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        
          // Omit rather than write the literal string "null" as a line-item property on the order.
          if (comparePrice !== null) formData.append('properties[_compare_price]', comparePrice);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Main-PDP add_to_cart analytics (see pushPdpAddToCartEvent above), pushed only for a
            // successful add, with the line this add just created/updated — the /cart/add.js
            // response IS that cart line, so no /cart.js re-read (which also used to fall back to
            // an unrelated cart.items[0] and fired even when the add had failed). quantity = the
            // amount just added, not the line's running total. Gated on the product template
            // (collection quick-add has its own events) and skipped for custom-size adds, as
            // before. Runs after the drawer update below so GTM's listeners don't delay it.
            if (!checkIsCustom && document.body.classList.contains('template-product')) {
              const addedVariantId = parseInt(formData.get('id'), 10);
              const addedLine = Array.isArray(response.items)
                ? response.items.find((item) => item.variant_id === addedVariantId)
                : response;
              if (addedLine && addedLine.variant_id) {
                const addedQty = parseInt(formData.get('quantity') || qtyInput?.value, 10) || 1;
                setTimeout(() => pushPdpAddToCartEvent({ ...addedLine, quantity: addedQty }, isFromSticky), 0);
              }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response,false);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {

              isDrawer = true;
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response,isDrawer);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            let isAddOnProduct = document.querySelector("[name='addOnProduct']")?.checked;

            //custom addToCart with mainProduct
                let itemArr = [];
                let timestamp = Date.now(); 
                let personalizationElem = document.querySelector(".personalize_product_block");
            
                // Object to store items
                let item_obj = {};
            
                // // Check for Personalization
                // if (personalizationElem) {
                //   let personlization_text = document.querySelector("#textInput").value;
                //   let checkPersonliazation = personalizationElem.querySelector(".personalization_result");
                //   let isPersonlization = checkPersonliazation.getAttribute("personlization");
          
                //   if (isPersonlization) {
                //     let pro_var_id = personalizationElem.querySelector(".product_wrapper").getAttribute("data-personalize-id");
                //     item_obj[pro_var_id] = {
                //       id: pro_var_id,
                //       quantity: qtyInput.value,
                //       properties: {
                //         "_isPersonalized": true,
                //         "_bundle_unique_id": window.productTimestamp,
                //         "personlization_text": personlization_text
                //       }
                //     };
                //   }
                // }
            
                // Check for Add-On Product
                
                if (isAddOnProduct) {
                  let addOnproductid = document.querySelector(".addOnProducts-wrapper .product_wrapper").getAttribute("data-addon-id");
                  if (addOnproductid) {
                    item_obj[addOnproductid] = {
                      id: addOnproductid,
                      quantity: qtyInput.value
                    };

                    // Whichever add-on product was ticked (protector, pillow, cover, …) was added on ATC.
                    // Read the authoritative add-on product data (rendered server-side), NOT hardcoded,
                    // and match the shape used by the pdp_addon view_item_list / select_item events.
                    if (window.SCAnalytics) {
                      const _dataEl = document.querySelector('[id^="pdp-addon-data-"]');
                      let _addon = null;
                      try { _addon = _dataEl ? JSON.parse(_dataEl.textContent) : null; } catch (e) { _addon = null; }
                      if (_addon) {
                        const _qty = parseInt(qtyInput.value, 10) || 1;
                        // Prefer the currently-selected variant/price from the DOM (reflects swatch choice),
                        // fall back to the server-rendered defaults.
                        const _colorEl = document.querySelector(".addOnProducts-wrapper .variant_list .selected_val");
                        const _priceEl = document.querySelector(".addOnProducts-wrapper .sale_price");
                        const _domPrice = _priceEl ? (parseFloat(_priceEl.getAttribute("data-sale_price")) || 0) / 100 : 0;
                        const _price = _domPrice || _addon.price || 0;
                        window.SCAnalytics.push('add_to_cart_upsell', {
                          section_name: 'pdp_addon',
                          ecommerce: {
                            currency: 'INR',
                            value: +(_price * _qty).toFixed(2),
                            items: [{
                              item_id: _addon.item_id,
                              item_name: _addon.item_name,
                              item_brand: _addon.item_brand,
                              item_category: _addon.item_category,
                              item_variant: (_colorEl && _colorEl.textContent.trim()) || _addon.item_variant,
                              price: _price,
                              quantity: _qty,
                              item_list_id: 'pdp_addon',
                              item_list_name: 'Add-on Cross-sell'
                            }]
                          }
                        });
                      }
                    }
                  }
                }
            
                // Convert object values to an array
                itemArr = Object.values(item_obj);
            
                if (itemArr.length > 0) {
                    const form_data = { items: itemArr };
                    custom_addtocart_fun(form_data, true); // Call only once
                }
             //custom addToCart with mainProduct
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if(document.body.classList.contains('template-product')){
            document.querySelector(".product-sticky-bar-wrap .loading__spinner").classList.add('hidden');
            }

            if(document.body.classList.contains('template-quiz-page')){
              window.location = window.routes.cart_url;
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
